import { useFormikContext } from 'formik'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { SIZE } from '../../../../constants/size'
import {
  FormBody,
  FormFieldsContainer,
  FormInlineNotifications,
  useFormValidationErrorsNotification,
} from '../../../Form'
import { Content } from '../../../Modal'

import { BuildingField } from './BuildingField'
import { ContractIdField } from './ContractIdField'
import { DelayedDateField } from './DelayedDateField'
import { DurationField } from './DurationField'
import { EndDateField } from './EndDateField'
import { FlatField } from './FlatField'
import { SecondContractIdField } from './SecondContractIdField'
import { StartDateField } from './StartDateField'
import { UserField } from './UserField'

import * as styles from './FormFields.module.css'

function FormFields({
  ContentComponent = Content,
  buildingFieldProps = EMPTY_OBJECT,
  contentComponentProps: {
    size: contentSize = SIZE.X_LARGE,
    ...contentComponentProps
  } = EMPTY_OBJECT,
  delayedDateFieldProps = EMPTY_OBJECT,
  durationFieldProps = EMPTY_OBJECT,
  flatFieldProps = EMPTY_OBJECT,
  notifications,
  submitButtonProps = EMPTY_OBJECT,
  userFieldProps = EMPTY_OBJECT,
  onCancel,
  onRemoveNotification,
  onSetNotification,
}) {
  const { dirty, isSubmitting } = useFormikContext()

  function handleCancel() {
    onCancel({ dirty })
  }

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        UploadComponent: false,
        cancelProps: {
          onClick: handleCancel,
        },
        className: styles.actions,
        submitProps: {
          ...submitButtonProps,
          isLoading: isSubmitting,
        },
      }}
    >
      <ContentComponent {...contentComponentProps} size={contentSize}>
        <FormInlineNotifications notifications={notifications} />
        <FormFieldsContainer className={styles.fieldsContainer}>
          <UserField {...userFieldProps} />
          <BuildingField {...buildingFieldProps} />
          <FlatField {...flatFieldProps} />
          <ContractIdField />
          <SecondContractIdField />
          <StartDateField />
          <EndDateField />
          <DelayedDateField {...delayedDateFieldProps} />
          <DurationField {...durationFieldProps} />
        </FormFieldsContainer>
      </ContentComponent>
    </FormBody>
  )
}

export default FormFields
